// Sistema de videos de envases para Shopify - VERSIÓN FINAL CON SELECTOR UNISEX
// Adaptado a URLs: /mujeres/, /hombres/, /fragancias-unisex/
(function () {
    'use strict';

    console.log('🎬 Sistema de videos de envases iniciado (URLs Específicas + Selector Unisex)');

    // 1. VIDEOS DAMA
    const envaseVideosDama = {
        '50 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/ff293b9218b94942b69564751277fb77.mp4', title: 'Modelo 1 · 50ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/3b2b96fdc315481fa842ed5e247fd443.mp4', title: 'Modelo 2 · 50ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/a16027e4ec344161bad111dbd3f25b62.mp4', title: 'Modelo 3 · 50ml', desc: 'Elige tu envase favorito' }
        ],
        '65 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/2f674619c3374e7f8ea24784c7987575.mp4', title: 'Modelo 1 · 65ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/46c3d5e9e9d9486987054faf4f017c93.mp4', title: 'Modelo 2 · 65ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/a11302075ce34dc487ce3e31da55cb48.mp4', title: 'Modelo 3 · 65ml', desc: 'Elige tu envase favorito' }
        ],
        '80 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/933d35bd86594d8481f9012417e8afca.mp4', title: 'Modelo 1 · 80ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/1e2487bfae764a7389e201f288427c4b.mp4', title: 'Modelo 2 · 80ml', desc: 'Elige tu envase favorito' },
        ],
        '100 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/50928de3973d41a19ea84c99080f1337.mp4', title: 'Modelo 1 · 100ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/549e87b373e44fe8b5bca668b8120c89.mp4', title: 'Modelo 2 · 100ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/627d232fec5042219c392526b4052ff7.mp4', title: 'Modelo 3 · 100ml', desc: 'Elige tu envase favorito' }
        ]
    };

    // 2. VIDEOS CABALLERO
    const envaseVideosCaballero = {
        '50 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/0eb41037a8a34c1694b78ce4d3bc3b2c.mp4', title: 'Modelo 1 · 50ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/be3dd56caa4740638832867b08f814c8.mp4', title: 'Modelo 2 · 50ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/3331917c317d44629b5c02cb1c117fd5.mp4', title: 'Modelo 3 · 50ml', desc: 'Elige tu envase favorito' }
        ],
        '65 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/910794fbf4fa483fb43cdd1a95299433.mp4', title: 'Modelo 1 · 65ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/25a807803f6748be8a4e0520f931a383.mp4', title: 'Modelo 2 · 65ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/751ee422db994953b7b0b95d427aad3a.mp4', title: 'Modelo 3 · 65ml', desc: 'Elige tu envase favorito' }
        ],
        '80 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/565c3a62de8e42fdb9ef1333b1f576c2.mp4', title: 'Modelo 1 · 80ml', desc: 'Elige tu envase favoritos' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/7b4ae8fb952f41fb8eec2d27ab423af4.mp4', title: 'Modelo 2 · 80ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/eb19946e388141a0946cc7532841eca4.mp4', title: 'Modelo 3 · 80ml', desc: 'Elige tu envase favorito' }
        ],
        '100 ml': [
            { src: 'https://cdn.shopify.com/videos/c/o/v/c53e3b814fa44ce283e4cd330f2135d6.mp4', title: 'Modelo 1 · 100ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/8339f971b38f42878db94dee79816f82.mp4', title: 'Modelo 2 · 100ml', desc: 'Elige tu envase favorito' },
            { src: 'https://cdn.shopify.com/videos/c/o/v/766b3e19c82c4ecb87a00ef2b5389ee5.mp4', title: 'Modelo 3 · 100ml', desc: 'Elige tu envase favorito' }
        ]
    };

    // 3. VIDEOS UNISEX - Estructurado por género para selector dinámico
    const envaseVideosUnisex = {
        '50 ml': {
            dama: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/ff293b9218b94942b69564751277fb77.mp4', title: 'Femenino · Modelo 1 · 50ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/3b2b96fdc315481fa842ed5e247fd443.mp4', title: 'Femenino · Modelo 2 · 50ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/a16027e4ec344161bad111dbd3f25b62.mp4', title: 'Femenino · Modelo 3 · 50ml', desc: 'Elige tu envase favorito' }
            ],
            caballero: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/0eb41037a8a34c1694b78ce4d3bc3b2c.mp4', title: 'Masculino · Modelo 1 · 50ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/be3dd56caa4740638832867b08f814c8.mp4', title: 'Masculino · Modelo 2 · 50ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/3331917c317d44629b5c02cb1c117fd5.mp4', title: 'Masculino · Modelo 3 · 50ml', desc: 'Elige tu envase favorito' }
            ]
        },
        '65 ml': {
            dama: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/2f674619c3374e7f8ea24784c7987575.mp4', title: 'Femenino · Modelo 1 · 65ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/46c3d5e9e9d9486987054faf4f017c93.mp4', title: 'Femenino · Modelo 2 · 65ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/a11302075ce34dc487ce3e31da55cb48.mp4', title: 'Femenino · Modelo 3 · 65ml', desc: 'Elige tu envase favorito' }
            ],
            caballero: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/910794fbf4fa483fb43cdd1a95299433.mp4', title: 'Masculino · Modelo 1 · 65ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/25a807803f6748be8a4e0520f931a383.mp4', title: 'Masculino · Modelo 2 · 65ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/751ee422db994953b7b0b95d427aad3a.mp4', title: 'Masculino · Modelo 3 · 65ml', desc: 'Elige tu envase favorito' }
            ]
        },
        '80 ml': {
            dama: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/933d35bd86594d8481f9012417e8afca.mp4', title: 'Femenino · Modelo 1 · 80ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/1e2487bfae764a7389e201f288427c4b.mp4', title: 'Femenino · Modelo 2 · 80ml', desc: 'Elige tu envase favorito' }
            ],
            caballero: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/565c3a62de8e42fdb9ef1333b1f576c2.mp4', title: 'Masculino · Modelo 1 · 80ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/7b4ae8fb952f41fb8eec2d27ab423af4.mp4', title: 'Masculino · Modelo 2 · 80ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/eb19946e388141a0946cc7532841eca4.mp4', title: 'Masculino · Modelo 3 · 80ml', desc: 'Elige tu envase favorito' }
            ]
        },
        '100 ml': {
            dama: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/50928de3973d41a19ea84c99080f1337.mp4', title: 'Femenino · Modelo 1 · 100ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/549e87b373e44fe8b5bca668b8120c89.mp4', title: 'Femenino · Modelo 2 · 100ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/627d232fec5042219c392526b4052ff7.mp4', title: 'Femenino · Modelo 3 · 100ml', desc: 'Elige tu envase favorito' }
            ],
            caballero: [
                { src: 'https://cdn.shopify.com/videos/c/o/v/c53e3b814fa44ce283e4cd330f2135d6.mp4', title: 'Masculino · Modelo 1 · 100ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/8339f971b38f42878db94dee79816f82.mp4', title: 'Masculino · Modelo 2 · 100ml', desc: 'Elige tu envase favorito' },
                { src: 'https://cdn.shopify.com/videos/c/o/v/766b3e19c82c4ecb87a00ef2b5389ee5.mp4', title: 'Masculino · Modelo 3 · 100ml', desc: 'Elige tu envase favorito' }
            ]
        }
    };


    const state = {
        currentSize: null,
        currentIndex: 0,
        autoCloseTimer: null,
        isInitialized: false,
        retryCount: 0,
        maxRetries: 15, // AUMENTADO PARA RESISTIR FALLOS DE FASTBUNDLE
        detectTimer: null,
        isSwitching: false,
        unisexGender: null // 'dama' o 'caballero' - selección del usuario en categoría unisex
    };

    const config = {
        autoShowDelay: 200,
        autoCloseDelay: 25000,
        retryDelays: [500, 1000, 1500, 2000, 3000, 4000, 5000, 5000, 5000],
        debugMode: true,
        detectDebounce: 120,
        closeOnSizeChange: false,
        allowAutoShow: true,
        alwaysAutoShow: true,
        enforceCollection: true, // Se activa para filtrar mejor
        
        // Solo estas categorías activarán el botón
        collectionNames: {
            dama: ['mujeres', 'perfumes femeninos', 'dama', 'women', 'mujer'],
            caballero: ['hombres', 'perfumes masculinos', 'caballero', 'men', 'hombre'],
            unisex: ['fragancias-unisex', 'fragancias unisex', 'unisex', 'ambos']
        },

        ui: {
            pulseMainButton: true,
            pulseMs: 1600,
            highlightAddToCartOnClose: true
        },
        mainButtonText: 'Toca aquí para ver los modelos de envases disponibles',
        
        buttonBehavior: {
            // CAMBIO CLAVE: false hace que el botón NO aparezca si no es perfume
            alwaysVisible: false, 
            disabledText: 'Selecciona un tamaño para ver envases'
        },

        helper: {
            enabled: false,
            text: 'Recuerda seleccionar envase favorito arriba👆'
        },
        shopifySelectors: {
            variantSelect: 'select[name="id"]',
            optionSelects: 'select[name*="option"], select[name*="Size"], select[name*="Tamaño"], select[name="id"]',
            variantRadios: 'input[type="radio"][name*="option"], input[type="radio"][name*="size"]',
            variantButtons: '.variant-input--button, .swatch, [class*="variant-option"], [data-value], .single-option-selector',
            productForm: 'form[action*="/cart/add"]'
        }
    };

    // FUNCIONES UTILS
    const log = (icon, message, data = null) => {
        if (config.debugMode) console.log(`${icon} [EnvaseVideos] ${message}`, data || '');
    };

    function ensureStyles() {
        if (document.getElementById('envase-videos-styles')) return;
        const style = document.createElement('style');
        style.id = 'envase-videos-styles';
        style.textContent = `
            @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700&display=swap');

            @keyframes envaseSlideDown { 
                from { opacity: 0; transform: translateY(-10px); } 
                to { opacity: 1; transform: translateY(0); } 
            }
            @keyframes envaseHeartbeat { 
                0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0,30,96,0.2); } 
                14% { transform: scale(1.03); } 
                28% { transform: scale(1); box-shadow: 0 0 0 10px rgba(0,30,96,0); } 
            }

            .envase-main-button { 
                font-family: 'Outfit', sans-serif !important;
                display: flex !important;
                justify-content: center;
                align-items: center;
                width: 100%;
                max-width: 520px;
                margin: 12px auto;
                background: background: #33414E !important;
                color: #fff !important;
                border: none;
                border-radius: 50px;
                padding: 18px 24px;
                font-weight: 700;
                cursor: pointer;
                font-size: 16px;
                letter-spacing: 0.5px;
                box-shadow: 0 10px 20px rgba(0,30,96,0.15);
                transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                position: relative;
                overflow: hidden;
            }
            .envase-main-button:hover { 
                transform: translateY(-2px);
                box-shadow: 0 15px 25px rgba(0,30,96,0.2);
            }
            .envase-main-button.envase-heartbeat { 
                animation: envaseHeartbeat 2.5s ease-in-out infinite; 
            }
            
            .envase-helper-text { 
                font-family: 'Outfit', sans-serif;
                display: block;
                background: rgba(0,30,96,0.03);
                color: #33414E;
                font-weight: 600;
                text-align: center;
                font-size: 13px;
                margin: 0 auto 8px;
                padding: 8px 12px;
                border-radius: 8px;
                max-width: 520px;
                border: 1px dashed #33414E;
            }

            #envase-video-container-inline {
                font-family: 'Outfit', sans-serif;
                animation: envaseSlideDown 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
            }

            .envase-gender-btn {
                transition: all 0.3s ease;
                border: 1px solid #eee !important;
                box-shadow: 0 4px 6px rgba(0,0,0,0.02);
            }
            #envase-gender-dama:hover { 
                border-color: #e91e63 !important;
                background: #fff0f5 !important;
                transform: translateY(-3px);
            }
            #envase-gender-caballero:hover { 
                border-color: #33414E !important;
                background: #f0f7ff !important;
                transform: translateY(-3px);
            }

            .video-controls button:disabled {
                opacity: 0.3;
                cursor: not-allowed;
                filter: grayscale(1);
            }

            .envase-video-close:hover {
                background: #ff4d4d !important;
                color: #fff !important;
                transform: rotate(90deg);
                transition: all 0.3s ease;
            }
        `;
        document.head.appendChild(style);
    }

    // NORMALIZACIÓN
    function normalizeForMatch(value) {
        if (!value) return '';
        return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function normalizeKeywordList(list) {
        return (list || []).map(normalizeForMatch);
    }

    function includesAnyKeywordNormalized(target, keywords) {
        if (!target) return false;
        const padded = ` ${target} `;
        return keywords.some(k => padded.includes(` ${k} `));
    }

    // CATEGORÍA
    // CATEGORÍA (Lógica Robusta "A Prueba de Balas")
    function getActiveCategory() {
        const path = window.location.pathname.toLowerCase();
        const href = window.location.href.toLowerCase();
        const search = window.location.search.toLowerCase();

        // --- 0. DETECCION QUERY PARAMS (Para test.html) ---
        if (search.includes('cat=unisex')) {
            log('✅', 'Categoría detectada por query param: UNISEX');
            return 'unisex';
        }
        if (search.includes('cat=caballero') || search.includes('cat=hombre')) {
            log('✅', 'Categoría detectada por query param: CABALLERO');
            return 'caballero';
        }
        if (search.includes('cat=dama') || search.includes('cat=mujer')) {
            log('✅', 'Categoría detectada por query param: DAMA');
            return 'dama';
        }

        // --- 1. DETECCION URL (Prioridad Absoluta y Rápida) ---
        // Buscamos strings literales definidos por el usuario, sin normalización compleja que pueda fallar.

        if (path.includes('/fragancias-unisex/') || path.includes('/unisex/')) {
            log('✅', 'Categoría detectada por URL (Match Exacto): UNISEX');
            return 'unisex';
        }
        if (path.includes('/hombres/') || path.includes('/caballero/') || path.includes('/masculinos/')) {
            log('✅', 'Categoría detectada por URL (Match Exacto): CABALLERO');
            return 'caballero';
        }
        if (path.includes('/mujeres/') || path.includes('/dama/') || path.includes('/femeninos/')) {
            log('✅', 'Categoría detectada por URL (Match Exacto): DAMA');
            return 'dama';
        }

        // --- 2. DETECCION META TAGS (Shopify Standard) ---
        if (window.meta && window.meta.product && window.meta.product.tags) {
            const tags = window.meta.product.tags.map(t => t.toLowerCase());
            if (tags.some(t => t.includes('unisex'))) return 'unisex';
            if (tags.some(t => t.includes('hombre') || t.includes('caballero'))) return 'caballero';
            if (tags.some(t => t.includes('mujer') || t.includes('dama'))) return 'dama';
        }

        // --- 3. DETECCION TEXTO DOM (Último recurso) ---
        // Buscar en H1 o Breadcrumbs
        const pageText = (document.title + ' ' + (document.querySelector('h1')?.textContent || '')).toLowerCase();
        if (pageText.includes('unisex')) return 'unisex';
        if (pageText.includes('hombre') || pageText.includes('caballero')) return 'caballero';
        if (pageText.includes('mujer') || pageText.includes('dama')) return 'dama';

        // --- 4. FALLBACK "A PRUEBA DE ERRORES" ---
        // Si todo falla, no retornamos null para evitar que el script muera.
        // Asumimos 'dama' (Suele ser la categoría principal) o 'unisex' si queremos cubrir todo.
        log('⚠️', 'No se detectó categoría específica. Usando fallback: UNISEX');
        return 'unisex';
    }

    function getVideoSet() {
        const cat = getActiveCategory();
        if (cat === 'caballero') return envaseVideosCaballero;
        if (cat === 'dama') return envaseVideosDama;
        if (cat === 'unisex') {
            // Para unisex, retornamos un objeto con las mismas claves de tamaño
            // pero los videos dependen de la selección del género
            const result = {};
            Object.keys(envaseVideosUnisex).forEach(size => {
                // Si hay género seleccionado, retornamos solo esos videos
                // Si no hay selección, retornamos array vacío (forzará selector)
                if (state.unisexGender && envaseVideosUnisex[size][state.unisexGender]) {
                    result[size] = envaseVideosUnisex[size][state.unisexGender];
                } else {
                    // Retornamos un placeholder para que el tamaño sea reconocido
                    result[size] = [];
                }
            });
            return result;
        }
        // Fallback por defecto
        return {};
    }

    // Función auxiliar para verificar si hay videos disponibles para unisex
    function hasUnisexVideosForSize(size) {
        return envaseVideosUnisex[size] &&
            (envaseVideosUnisex[size].dama?.length > 0 || envaseVideosUnisex[size].caballero?.length > 0);
    }

    // Obtener videos unisex según género seleccionado
    function getUnisexVideos(size, gender) {
        if (!envaseVideosUnisex[size]) return [];
        return envaseVideosUnisex[size][gender] || [];
    }

    // DETECCIÓN DE TAMAÑO (Dinámica)
    function detectSize(text) {
        if (!text) return null;
        const cleanText = text.toLowerCase().replace(/[^a-z0-9]/g, '');

        // Tamaños válidos (hardcoded para consistencia)
        const validSizes = ['50 ml', '65 ml', '80 ml', '100 ml'];

        for (const sizeKey of validSizes) {
            const cleanKey = sizeKey.toLowerCase().replace(/[^a-z0-9]/g, '');
            if (cleanText.includes(cleanKey)) return sizeKey;
        }
        return null; // No coincidencia
    }

    // Verificar si hay videos disponibles para un tamaño
    function hasVideosForSize(size) {
        const cat = getActiveCategory();
        if (cat === 'unisex') {
            return hasUnisexVideosForSize(size);
        }
        const videoSet = getVideoSet();
        return videoSet[size] && videoSet[size].length > 0;
    }

    // ESTADO
    function updateState(newSize) {
        if (state.currentSize !== newSize) {
            const oldSize = state.currentSize;
            state.currentSize = newSize;
            state.currentIndex = 0;
            updateButton();

            // Refrescar visor si está abierto
            const wrapper = document.getElementById('envase-video-container-inline');
            if (wrapper && wrapper.style.display !== 'none' && wrapper.style.display !== '') {
                log('🔄', `Tamaño cambió de ${oldSize} a ${newSize}. Refrescando visor...`);
                loadCurrentVideo();
            }
        }
    }

    function detectCurrentSize() {
        // Buscar en selects (FastBundle suele inyectar aquí o crear botones custom)
        const selects = document.querySelectorAll(config.shopifySelectors.optionSelects);
        for (const s of selects) {
            const opt = s.options[s.selectedIndex];
            if (opt) {
                const sz = detectSize(opt.textContent) || detectSize(opt.value);
                if (sz && hasVideosForSize(sz)) return sz;
            }
        }
        // Buscar en botones y radios (Input radios o botones de tema)
        // Refactorizado para ser más seguro: buscamos TODOS los botones posibles y verificamos si tienen clase activa
        // Esto evita errores de sintaxis al concatenar selectores complejos con comas
        const potentialButtons = document.querySelectorAll(config.shopifySelectors.variantButtons);
        for (const el of potentialButtons) {
            // Verificar si está activo
            const isActive = el.classList.contains('is-active') ||
                el.classList.contains('active') ||
                el.classList.contains('selected') ||
                el.getAttribute('aria-selected') === 'true';

            if (isActive) {
                const sz = detectSize(el.textContent) || detectSize(el.getAttribute('data-value'));
                if (sz && hasVideosForSize(sz)) return sz;
            }
        }

        // Buscar labels de radios checked separados (común en Shopify)
        const checkedRadiosLabels = document.querySelectorAll('input[type="radio"]:checked + label');
        for (const el of checkedRadiosLabels) {
            const sz = detectSize(el.textContent);
            if (sz && hasVideosForSize(sz)) return sz;
        }
        // Fallback genérico para clases 'active'/'selected' generales
        const generic = document.querySelectorAll('.active, .selected, [aria-selected="true"]');
        for (const el of generic) {
            const sz = detectSize(el.textContent);
            if (sz && hasVideosForSize(sz)) return sz;
        }
        return null;
    }

    function tryDetectAndShow() {
        // Asegurarnos que el botón existe y tiene listeners en cada ciclo de detección
        ensureMainButton();

        const sz = detectCurrentSize();
        if (sz !== state.currentSize) {
            updateState(sz);
            if (sz) log('📏', 'Nuevo tamaño detectado:', sz);
        }
    }

    function detectWithRetry() {
        if (state.retryCount >= state.maxRetries) {
            log('⚠️', 'Máximo de reintentos de detección alcanzado (FastBundle puede estar lento o caído)');
            return;
        }
        state.retryCount++;
        tryDetectAndShow();

        // Si no encontró tamaño, reintentar con delays incrementales
        if (!state.currentSize) {
            const delay = config.retryDelays[Math.min(state.retryCount, config.retryDelays.length - 1)] || 5000;
            setTimeout(detectWithRetry, delay);
        }
    }

    function scheduleDetect() {
        if (state.detectTimer) clearTimeout(state.detectTimer);
        state.detectTimer = setTimeout(tryDetectAndShow, config.detectDebounce);
    }

    // Nueva función para manejar clicks y detectar tamaño optimísticamente
    function handleGlobalClick(e) {
        scheduleDetect(); // Comportamiento normal (debounce)

        // Detección "Optimista" basada en el elemento clickeado
        // Esto ayuda si la clase 'active' tarda en llegar o no es estándar
        try {
            const target = e.target;
            const text = target.textContent || target.value || '';
            const potentialSize = detectSize(text);

            // Si clickeamos algo que PARECE un tamaño, intentamos actualizar
            if (potentialSize && hasVideosForSize(potentialSize)) {
                log('👆', 'Click en posible selector de tamaño:', potentialSize);

                // Forzamos una chequeo rápido
                setTimeout(() => {
                    const current = detectCurrentSize();
                    if (current === potentialSize) {
                        tryDetectAndShow();
                    } else {
                        // Si detectCurrentSize no lo ve (porque no tiene class active aún),
                        // podriamos forzarlo si confiamos en el click.
                        // Por seguridad, solo logueamos y reintentamos en un momento.
                        log('⏳', 'Esperando actualización de clase active...');
                    }
                }, 50);

                // Reintentos agresivos para atrapar el cambio de clase
                setTimeout(tryDetectAndShow, 200);
                setTimeout(tryDetectAndShow, 500);
                setTimeout(tryDetectAndShow, 1000);
            } else {
                // Si no es un tamaño, igual rechequeamos por si fue un click en un contenedor
                setTimeout(tryDetectAndShow, 200);
            }
        } catch (err) {
            // Ignorar errores en handler de click
        }
    }


    // INTERFAZ (BOTÓN)
    function ensureMainButton() {
        let btn = document.getElementById('show-envase-video-btn');
        let created = false;

        if (!btn) {
            // Buscar el formulario de manera más flexible
            let form = document.querySelector(config.shopifySelectors.productForm);

            // Fallback: buscar cualquier form en la página
            if (!form) {
                form = document.querySelector('form[action*="/cart"]');
            }
            if (!form) {
                form = document.querySelector('form');
            }

            // Fallback final: crear en el body si no hay form
            if (!form) {
                // log('⚠️', 'No se encontró formulario, insertando en body');
                const container = document.querySelector('.product, .product-form, main, #main, body');
                if (container) {
                    form = document.createElement('div');
                    form.style.cssText = 'width:100%;max-width:600px;margin:20px auto;padding:20px;';
                    container.insertBefore(form, container.firstChild);
                }
            }

            if (form) {
                ensureStyles();
                btn = document.createElement('button');
                btn.type = 'button';
                btn.id = 'show-envase-video-btn';
                btn.className = 'envase-main-button';

                // Buscar elemento hermano para insertar antes (ej: botón de carrito)
                const cartBtn = form.querySelector('[name="add"], .add-to-cart, button[type="submit"]');

                // Estilos inline críticos (Diseño Premium con Degradado)
                btn.style.cssText = 'display:flex !important;justify-content:center;align-items:center;width:100%;max-width:520px;margin:12px auto;background: #33414E;color:#fff;border:none;border-radius:50px;padding:18px 24px;font-weight:700;cursor:pointer;font-size:16px;letter-spacing:0.5px;box-shadow:0 10px 20px rgba(0,30,96,0.15);text-align:center;line-height:1.35;z-index:10;position:relative;transition:all 0.3s ease;';
                btn.textContent = config.mainButtonText;

                // Insertar antes del botón de carrito si existe, o al principio
                if (cartBtn && cartBtn.parentNode === form) {
                    form.insertBefore(btn, cartBtn);
                } else if (form.firstChild) {
                    form.insertBefore(btn, form.firstChild);
                } else {
                    form.appendChild(btn);
                }
                created = true;

                if (config.helper.enabled) {
                    const help = document.createElement('div');
                    help.textContent = config.helper.text;
                    help.className = 'envase-helper-text';
                    form.insertBefore(help, btn);
                }
            }
        }

        if (btn) {
            // RE-VINCULAR SIEMPRE EL LISTENER (Para contrarrestar clones o pérdidas)
            btn.onclick = showVideo; // Usar onclick directo es más fuerte que addEventListener contra duplicados

            // Actualizar estado visual
            updateButton();

            if (created) log('✅', 'Botón principal creado e insertado');
        } else {
            // log('❌', 'No se pudo crear el botón');
        }
    }

    function updateButton() {
        const btn = document.getElementById('show-envase-video-btn');
        if (!btn) return;

        // Verificar si hay videos para el tamaño actual
        const hasVideos = state.currentSize && hasVideosForSize(state.currentSize);

        if (hasVideos) {
            btn.removeAttribute('disabled');
            btn.textContent = config.mainButtonText;
            btn.style.opacity = '1';
            btn.style.cursor = 'pointer';
            btn.style.display = 'flex';
            if (config.ui.pulseMainButton) btn.classList.add('envase-heartbeat');
        } else {
            btn.setAttribute('disabled', 'true');
            btn.style.opacity = '0.7';
            btn.style.cursor = 'not-allowed';
            btn.classList.remove('envase-heartbeat');

            if (config.buttonBehavior.alwaysVisible) {
                btn.textContent = config.buttonBehavior.disabledText;
                btn.style.display = 'flex';
            } else {
                btn.style.display = 'none';
            }
        }

        log('🔘', `Botón actualizado - Videos disponibles: ${hasVideos}, Tamaño: ${state.currentSize}`);
    }

    // INTERFAZ (MODAL)
    // INTERFAZ (INLINE / DESPLEGABLE)
    // Refactorizado para desplegarse "ahí mismo" (inline) debajo del botón
    function ensureModalExists() {
        const existingContainer = document.getElementById('envase-video-container-inline');

        // Limpieza de cualquier modal antiguo flotante que pudiera quedar
        const oldModal = document.getElementById('envase-video-modal');
        if (oldModal) oldModal.remove();

        if (existingContainer) return; // Ya existe

        const btn = document.getElementById('show-envase-video-btn');
        if (!btn || !btn.parentNode) return;

        log('hammer', 'Creando contenedor Inline...');

        const wrapper = document.createElement('div');
        wrapper.id = 'envase-video-container-inline';
        wrapper.style.cssText = `
            display:none; 
            width:100%; 
            max-width:520px; 
            margin:15px auto 0; 
            background:rgba(255,255,255,0.98); 
            border-radius:24px; 
            box-shadow: 0 20px 40px rgba(0,30,96,0.12), 0 0 0 1px rgba(0,30,96,0.05); 
            overflow:hidden; 
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            position: relative;
            z-index: 5;
        `;

        wrapper.innerHTML = `
            <div class="envase-video-content" style="position:relative; background:#fff;">
                <button type="button" class="envase-video-close" title="Cerrar" style="position:absolute; top:12px; right:12px; z-index:20; background:rgba(255,255,255,0.9); border:none; color:#1d1d1f; width:32px; height:32px; border-radius:50%; font-size:20px; cursor:pointer; display:flex; justify-content:center; align-items:center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">&times;</button>

                <!-- SELECTOR DE GÉNERO -->
                <div id="envase-gender-selector" style="display:none; padding:15px 15px 10px; text-align:center;">
    <h3 style="margin:0 0 12px; font-size:15px; color:#1d1d1f; font-weight:700;">Selecciona una Categoría</h3>
    <div style="display:flex; justify-content:center; gap:10px;">
        <button id="envase-gender-dama" class="envase-gender-btn" style="flex:1; padding:10px 5px; border-radius:12px; background:#fff; color:#e91e63; font-weight:700; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:4px; font-size:12px; border:1px solid #eee;">
            <span style="font-size:22px;">👩</span> Femenino
        </button>
        <button id="envase-gender-caballero" class="envase-gender-btn" style="flex:1; padding:10px 5px; border-radius:12px; background:#fff; color: #33414E; font-weight:700; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:4px; font-size:12px; border:1px solid #eee;">
            <span style="font-size:22px;">👨</span> Masculino
        </button>
    </div>
</div>

                <!-- REPRODUCTOR -->
                <div id="envase-video-active-area" style="display:none;">
                    <div class="video-header" style="padding:12px 18px; display:flex; justify-content:space-between; align-items:center; background:#fff; border-bottom:1px solid #f2f2f5;">
                        <div id="envase-gender-indicator" style="font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.5px; color: #33414E; background:rgba(0,30,96,0.06); padding:4px 12px; border-radius:20px;">
                            <span id="envase-current-gender">Ref. Envase</span>
                        </div>
                        <button id="envase-change-gender" style="position: absolute; left: 50%; transform: translateX(-50%); font-size:11px; color: #33414E; background:rgba(0,30,96,0.04); border:1px solid rgba(0,30,96,0.1); border-radius:6px; padding:4px 8px; cursor:pointer; font-weight:600; transition:all 0.2s;">Toca aquí para cambiar la categoría</button>
                    </div>

                    <div class="video-wrapper" style="position:relative; background:#fff; width:100% !important; height:auto; min-height:220px; max-height:380px; display:flex !important; align-items:center !important; justify-content:center !important; overflow:hidden;">
                        <video id="envase-video" autoplay loop muted playsinline style="max-height:360px; width:auto !important; max-width:100% !important; object-fit:contain; display:block; margin:0 auto;">
                            <source id="video-source" src="" type="video/mp4" />
                        </video>
                    </div>

                    <div class="video-footer" style="padding:24px; background:#fff;">
                        <div style="display:flex; justify-content:space-between; align-items:start; margin-bottom:18px;">
                            <div style="flex:1;">
                                <h4 id="envase-title" style="margin:0 0 4px; font-size:17px; color:#1d1d1f; font-weight:700; line-height:1.2;">Cargando...</h4>
                                <p id="envase-description" style="margin:0; font-size:13px; color:#6e6e73; line-height:1.4;">Elige tu envase favorito</p>
                            </div>
                            <span id="envase-counter" style="background:#001E60; color:#fff; padding:4px 12px; border-radius:20px; font-size:12px; font-weight:700;">1/1</span>
                        </div>

                        <div class="video-controls" style="display:flex; gap:12px;">
                            <button id="prev-envase" style="flex:1; padding:10px 12px; border:none; border-radius:10px; background:#33414E; color:#fff; font-weight:600; cursor:pointer; font-size:13px; display:flex; align-items:center; justify-content:center; gap:4px; transition:all 0.2s; box-shadow: 0 3px 10px rgba(51,65,78,0.2);">
    <span style="font-size:14px;">‹</span> Anterior
</button>

<button id="next-envase" style="flex:1; padding:10px 12px; border:none; border-radius:10px; background:#33414E; color:#fff; font-weight:600; cursor:pointer; font-size:13px; display:flex; align-items:center; justify-content:center; gap:4px; transition:all 0.2s; box-shadow: 0 3px 10px rgba(51,65,78,0.2);">
    Siguiente <span style="font-size:14px;">›</span>
</button>


                        </div>
                    </div>
                </div>
            </div>
        `;

        // Insertar justo DESPUÉS del botón (Inline)
        if (btn.nextSibling) {
            btn.parentNode.insertBefore(wrapper, btn.nextSibling);
        } else {
            btn.parentNode.appendChild(wrapper);
        }

        // Event listeners
        const closeBtn = wrapper.querySelector('.envase-video-close');
        if (closeBtn) closeBtn.onclick = closeVideo;

        const prevBtn = wrapper.querySelector('#prev-envase');
        const nextBtn = wrapper.querySelector('#next-envase');
        if (prevBtn) prevBtn.onclick = () => changeEnvase(-1);
        if (nextBtn) nextBtn.onclick = () => changeEnvase(1);

        const damaBtn = wrapper.querySelector('#envase-gender-dama');
        const cabBtn = wrapper.querySelector('#envase-gender-caballero');
        const changeGenBtn = wrapper.querySelector('#envase-change-gender');

        if (damaBtn) damaBtn.onclick = () => selectUnisexGender('dama');
        if (cabBtn) cabBtn.onclick = () => selectUnisexGender('caballero');
        if (changeGenBtn) changeGenBtn.onclick = showGenderSelector;
    }

    function selectUnisexGender(gender) {
        state.unisexGender = gender;
        state.currentIndex = 0;

        const wrapper = document.getElementById('envase-video-container-inline');
        if (!wrapper) return;

        const genderSelector = wrapper.querySelector('#envase-gender-selector');
        const videoArea = wrapper.querySelector('#envase-video-active-area');
        const currentGenderSpan = wrapper.querySelector('#envase-current-gender');
        const genderIndicator = wrapper.querySelector('#envase-gender-indicator');

        if (genderSelector) genderSelector.style.display = 'none';
        if (videoArea) videoArea.style.display = 'block';
        if (genderIndicator) genderIndicator.style.display = 'block';

        if (currentGenderSpan) {
            currentGenderSpan.textContent = gender === 'dama' ? '👩 Femenino' : '👨 Masculino';
        }

        loadCurrentVideo();
    }

    // Mostrar selector de género (volver a elegir)
    function showGenderSelector() {
        const wrapper = document.getElementById('envase-video-container-inline');
        if (!wrapper) return;

        const genderSelector = wrapper.querySelector('#envase-gender-selector');
        const videoArea = wrapper.querySelector('#envase-video-active-area');
        const video = document.getElementById('envase-video');

        if (genderSelector) genderSelector.style.display = 'block';
        if (videoArea) videoArea.style.display = 'none';

        if (video) video.pause();
    }

    function showVideo() {
        try {
            log('🎬', 'showVideo() ejecutándose', {
                currentSize: state.currentSize,
                category: getActiveCategory()
            });

            if (!state.currentSize) {
                log('⚠️', 'No hay tamaño seleccionado');
                const detectedNow = detectCurrentSize();
                if (detectedNow) {
                    state.currentSize = detectedNow;
                } else {
                    alert('Por favor, selecciona un tamaño primero.');
                    return;
                }
            }

            ensureModalExists();

            const wrapper = document.getElementById('envase-video-container-inline');
            if (!wrapper) {
                console.error('❌ Error: Contenedor inline no encontrado.');
                return;
            }

            // TOGGLE: Si ya está visible, lo cerramos
            if (wrapper.style.display !== 'none' && wrapper.style.display !== '') {
                closeVideo();
                return;
            }

            const cat = getActiveCategory();
            const genderSelector = wrapper.querySelector('#envase-gender-selector');
            const videoArea = wrapper.querySelector('#envase-video-active-area');
            const genderIndicator = wrapper.querySelector('#envase-gender-indicator');

            // Abrir
            wrapper.style.display = 'block';

            // CASO UNISEX: Mostrar selector SOLO si es categoría Unisex y no hay género
            if (cat === 'unisex' && !state.unisexGender) {
                log('👤', 'Categoría Unisex detectada -> Abriendo selector de género');
                if (genderSelector) genderSelector.style.display = 'block';
                if (videoArea) videoArea.style.display = 'none';
                return;
            }

            // CASO NORMAL: Ocultar selector y mostrar reproductor
            if (genderSelector) genderSelector.style.display = 'none';
            if (videoArea) videoArea.style.display = 'block';

            // Controles de categoría exclusivos de Unisex
            const changeGenBtn = wrapper.querySelector('#envase-change-gender');
            if (changeGenBtn) {
                changeGenBtn.style.display = (cat === 'unisex') ? 'inline-block' : 'none';
            }

            if (genderIndicator) {
                genderIndicator.style.display = (cat === 'unisex') ? 'block' : 'none';
            }

            loadCurrentVideo();
            log('✅', 'Caja de video desplegada');

        } catch (e) {
            console.error('❌ Error en showVideo:', e);
        }
    }

    // Función auxiliar para cargar el video actual
    function loadCurrentVideo() {
        const cat = getActiveCategory();
        let videos;

        log('🔍', 'Cargando video', { categoria: cat, tamaño: state.currentSize, género: state.unisexGender });

        // Obtener videos según categoría
        if (cat === 'unisex' && state.unisexGender) {
            videos = getUnisexVideos(state.currentSize, state.unisexGender);
            log('📦', `Videos unisex ${state.unisexGender}:`, videos?.length || 0);
        } else if (cat === 'dama') {
            videos = envaseVideosDama[state.currentSize];
            log('📦', 'Videos dama:', videos?.length || 0);
        } else if (cat === 'caballero') {
            videos = envaseVideosCaballero[state.currentSize];
            log('📦', 'Videos caballero:', videos?.length || 0);
        } else {
            const videoSet = getVideoSet();
            videos = videoSet[state.currentSize];
            log('📦', 'Videos desde getVideoSet():', videos?.length || 0);
        }

        if (!videos || !videos.length) {
            log('❌', `No hay videos para ${state.currentSize} en categoría ${cat}`);
            alert(`No hay videos disponibles para el tamaño ${state.currentSize}`);
            return;
        }

        // Validar índice
        if (state.currentIndex >= videos.length) state.currentIndex = 0;
        if (state.currentIndex < 0) state.currentIndex = videos.length - 1;

        const video = videos[state.currentIndex];
        const videoElement = document.getElementById('envase-video');
        const source = document.getElementById('video-source');
        const title = document.getElementById('envase-title');
        const description = document.getElementById('envase-description');
        const counter = document.getElementById('envase-counter');

        if (!videoElement || !source) {
            log('❌', 'Elementos del video no encontrados');
            return;
        }

        log('🎥', `Mostrando: ${video.title} (${state.currentIndex + 1}/${videos.length})`);

        // EFECTO VISUAL DE "RECARGA" (Feedback para el usuario)
        const activeArea = document.getElementById('envase-video-active-area');
        if (activeArea) {
            activeArea.style.transition = 'opacity 0.2s ease';
            activeArea.style.opacity = '0.3';
            setTimeout(() => activeArea.style.opacity = '1', 250);
        }

        // Configurar video
        source.src = video.src;
        if (title) title.textContent = video.title;
        if (description) description.textContent = video.desc || '';
        if (counter) counter.textContent = `${state.currentIndex + 1} de ${videos.length}`;

        // Cargar y reproducir
        videoElement.load();

        // Deshabilitar navegación si solo hay un video
        const prevBtn = document.getElementById('prev-envase');
        const nextBtn = document.getElementById('next-envase');
        if (prevBtn) prevBtn.disabled = (videos.length <= 1);
        if (nextBtn) nextBtn.disabled = (videos.length <= 1);

        log('✅', 'Video cargado exitosamente');
    }


    function changeEnvase(direction) {
        const cat = getActiveCategory();
        let videos;

        // Obtener videos según categoría
        if (cat === 'unisex' && state.unisexGender) {
            videos = getUnisexVideos(state.currentSize, state.unisexGender);
        } else {
            const videoSet = getVideoSet();
            videos = videoSet[state.currentSize];
        }

        if (!videos || !videos.length) return;

        const prevIndex = state.currentIndex;
        let nextIndex = prevIndex + (direction > 0 ? 1 : -1);

        // Navegación circular
        if (nextIndex < 0) nextIndex = videos.length - 1;
        if (nextIndex >= videos.length) nextIndex = 0;

        state.currentIndex = nextIndex;

        log('🔄', `Cambiando: ${direction > 0 ? 'SIGUIENTE' : 'ANTERIOR'} (${nextIndex + 1}/${videos.length})`);

        loadCurrentVideo();
    }

    function closeVideo() {
        log('🚪', 'Colapsando inline');
        const wrapper = document.getElementById('envase-video-container-inline');
        const video = document.getElementById('envase-video');

        if (wrapper) wrapper.style.display = 'none';
        if (video) video.pause();
    }

    // EXPORTAR HELPERS GLOBALMENTE INMEDIATAMENTE
    // Esto asegura que los onclick inline funcionen incluso antes de init()
    window.changeEnvase = changeEnvase;
    window.closeVideo = closeVideo;
    window.showVideo = showVideo;

    function diagnose() {
        const cat = getActiveCategory();
        const btn = document.getElementById('show-envase-video-btn');
        const form = document.querySelector(config.shopifySelectors.productForm);

        console.group('🔍 Diagnóstico EnvaseVideos (vFinal + Selector Unisex)');
        console.log('📍 URL:', window.location.href);
        console.log('🏷️ Categoría Detectada:', cat);
        console.log('📏 Tamaño Actual:', state.currentSize || 'NO DETECTADO');
        console.log('🔘 Botón Existe:', btn ? 'SÍ ✅' : 'NO ❌');
        console.log('📝 Formulario Existe:', form ? 'SÍ ✅' : 'NO ❌');
        console.log('🎬 Videos disponibles para tamaño actual:', state.currentSize ? hasVideosForSize(state.currentSize) : 'N/A');

        if (cat === 'unisex') {
            console.log('👤 Género Unisex Seleccionado:', state.unisexGender || 'No seleccionado');
            console.log('📦 Videos Unisex Disponibles:', envaseVideosUnisex);
        }

        console.log('🗂️ Set de Videos Activo:', getVideoSet());
        console.log('📊 Estado Completo:', state);

        // Diagnóstico de selectores
        console.log('🔍 Selectores encontrados:');
        console.log('  - Selects:', document.querySelectorAll(config.shopifySelectors.optionSelects).length);
        console.log('  - Radios:', document.querySelectorAll(config.shopifySelectors.variantRadios).length);
        console.log('  - Botones variante:', document.querySelectorAll(config.shopifySelectors.variantButtons).length);

        console.log('⚙️ FastBundle/Theme Status:', 'Si los botones de talla no cargan, esto fallará.');
        console.groupEnd();

        // Sugerencias
        if (!btn) {
            console.warn('💡 SUGERENCIA: El botón no existe. Ejecuta window.EnvaseVideos.createButton() para crearlo manualmente.');
        }
        if (!state.currentSize) {
            console.warn('💡 SUGERENCIA: No se detectó tamaño. Verifica que los selectores de variante estén cargados.');
        }
    }

    // INIT
    function init() {
        if (state.isInitialized) {
            log('⚠️', 'Ya inicializado, abortando...');
            return;
        }

        log('🚀', 'Iniciando sistema de envases...');
        log('📍', 'URL actual:', window.location.href);
        log('📦', 'Categoría detectada:', getActiveCategory());

        // Asegurar que el botón existe
        ensureMainButton();

        document.addEventListener('click', handleGlobalClick);
        document.addEventListener('change', scheduleDetect);

        // MutationObserver
        new MutationObserver(() => scheduleDetect()).observe(document.body, { childList: true, subtree: true });

        state.isInitialized = true;

        // Arrancar con reintentos para resistir carga lenta de FastBundle
        detectWithRetry();

        // Diagnóstico automático después de 2 segundos
        setTimeout(() => {
            diagnose();
            // Verificar que el botón siga existiendo
            const btn = document.getElementById('show-envase-video-btn');
            if (!btn) {
                log('❌', 'CRÍTICO: El botón no existe después de 2s. Reintentando...');
                ensureMainButton();
            }
        }, 2000);

        // API pública y Global Helpers (Para evitar ReferenceError en onclick inline)
        window.changeEnvase = changeEnvase;
        window.closeVideo = closeVideo;
        window.showVideo = showVideo;

        window.EnvaseVideos = {
            show: showVideo,
            close: closeVideo,
            diagnose,
            getCategory: getActiveCategory,
            setUnisexGender: selectUnisexGender,
            getState: () => ({ ...state }),
            forceInit: () => { state.isInitialized = false; init(); },
            createButton: ensureMainButton,
            // Función de prueba rápida (ignora detección de tamaño)
            test: (size = '50 ml', gender = null) => {
                log('🧪', `Modo prueba: tamaño=${size}, género=${gender || 'ninguno'}`);
                state.currentSize = size;
                state.currentIndex = 0;

                // Si se especifica un género, asumimos modo unisex
                if (gender) {
                    log('🧪', 'Forzando modo unisex con género:', gender);
                    state.unisexGender = gender;
                }

                updateButton();

                setTimeout(() => {
                    log('🧪', 'Abriendo modal de prueba...');
                    showVideo();
                }, 100);
            },
            // Listar videos disponibles
            listVideos: () => {
                const cat = getActiveCategory();
                console.group('📹 Videos Disponibles');
                console.log('Categoría:', cat);
                if (cat === 'dama') {
                    console.log('Videos Dama:', envaseVideosDama);
                } else if (cat === 'caballero') {
                    console.log('Videos Caballero:', envaseVideosCaballero);
                } else if (cat === 'unisex') {
                    console.log('Videos Unisex:', envaseVideosUnisex);
                }
                console.groupEnd();
            }
        };

        log('✅', 'Sistema inicializado correctamente');
    }

    // Inicialización inmediata y con reintentos
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Reintento adicional después de 1 segundo (por si el DOM se modifica después de cargar)
    setTimeout(() => {
        const btn = document.getElementById('show-envase-video-btn');
        if (!btn) {
            log('🔄', 'Botón no encontrado después de 1s, reintentando creación...');
            ensureMainButton();
        }
    }, 1000);

    // Reintento adicional después de 3 segundos (para temas que cargan lento)
    setTimeout(() => {
        const btn = document.getElementById('show-envase-video-btn');
        if (!btn) {
            log('🔄', 'Botón no encontrado después de 3s, último reintento...');
            ensureMainButton();
        }
    }, 3000);

})();